import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * It's supposed to work like basic <Trans> from i18next, but refreshing on language change
 */
export const TranslatePhrase: FunctionComponent<ITranslatePhraseProps> = ({
                                                                            i18nKey,
                                                                          }) => {
  const [t] = useTranslation()
  return <>{t(i18nKey)}</>
}

interface ITranslatePhraseProps {
  i18nKey: string
}
